import { type DependencyList, useRef } from 'react';
import isEqual from 'lodash/isEqual';

// Based on https://github.com/apollographql/apollo-client/blob/v3.9.10/src/react/hooks/internal/useDeepMemo.ts
export const useDeepMemo = <T,>(memoFn: () => T, deps: DependencyList) => {
	const ref = useRef<{ deps: DependencyList; value: T }>();

	if (!ref.current || !isEqual(ref.current.deps, deps)) {
		ref.current = { value: memoFn(), deps };
	}

	return ref.current.value;
};
